import { render, staticRenderFns } from "./IndexList.vue?vue&type=template&id=1fc86c2e"
import script from "./IndexList.vue?vue&type=script&lang=js"
export * from "./IndexList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports